<template>
    <div class="loader">
        <div
                class="lds-dual-ring"
        >

        </div>
    </div>
</template>
<script>
    export default {
        props: {
            loading: {
                type: Boolean,
                required: false,
                default: true
            },
            color: {
                type: String,
                required: false,
                default: 'black'
            }
        }
    }
</script>

<style scoped lang="scss">
    @import './../styles/variables';

    .loader{
        display: block;
        text-align: center;
        height: 100px;
    }

    .lds-dual-ring {
        margin-top: 32px;
        margin-bottom: 32px;
        display: inline-block;
        width: 64px;
        height: 64px;
    }
    .lds-dual-ring:after {
        content: " ";
        display: block;
        width: 46px;
        height: 46px;
        margin: 1px;
        border-radius: 50%;
        border: 5px solid #ffffff;
        animation: lds-dual-ring 1.2s linear infinite;
        border-color: var(--pallete_main_color) transparent var(--pallete_main_color) transparent;
    }
    @keyframes lds-dual-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>